import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import axios from 'axios';
import { url } from '../../../../env';
import { userDetailModalCSS, userDetailDialogStyle, roleChipCSS, stateChipCSS } from './UsersManagement.css';
import { initialsOf, labelOf } from './roleConfig';
import UserProfileTab from './UserProfileTab';
import UserRoleTab from './UserRoleTab';
import UserHistoryTab from './UserHistoryTab';

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth <= 650);
    useEffect(() => {
        const handler = () => setIsMobile(window.innerWidth <= 650);
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, []);
    return isMobile;
};

const UserDetailModal = ({ user, visible, onHide, onUpdate, toast }) => {
    const isMobile = useIsMobile();
    const [tabIndex, setTabIndex] = useState(0);
    const [currentUser, setCurrentUser] = useState(user);

    useEffect(() => {
        setCurrentUser(user);
        if (visible) setTabIndex(0);
    }, [user, visible]);

    if (!currentUser) return null;

    const reloadUser = async () => {
        try {
            const res = await axios.get(`${url}/users?search=${encodeURIComponent(currentUser.email)}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
            const fresh = (res.data?.data ?? []).find((u) => u.id === currentUser.id);
            if (fresh) setCurrentUser(fresh);
        } catch (e) {
            console.error('Reload user failed', e);
        }
        onUpdate?.();
    };

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            modal
            draggable={false}
            resizable={false}
            dismissableMask
            closeOnEscape
            style={userDetailDialogStyle(isMobile)}
            contentStyle={{
                padding: '20px',
                background: '#fefefe',
                borderRadius: isMobile ? '0.8rem 0.8rem 0 0' : '0.8rem',
            }}
            showHeader={false}
        >
            <div css={userDetailModalCSS()} className="fk-root">
                <header className="udm-header">
                    <div className="udm-avatar">{initialsOf(currentUser.name)}</div>
                    <div className="udm-identity">
                        <h2 className="udm-name">{currentUser.name || 'Sin nombre'}</h2>
                        <p className="udm-email">{currentUser.email}</p>
                        <div className="udm-chips">
                            <span css={roleChipCSS(currentUser.type_user)}>
                                {labelOf(currentUser.type_user)}
                            </span>
                            <span css={stateChipCSS(!!currentUser.is_active)}>
                                {currentUser.is_active ? 'Activo' : 'Inactivo'}
                            </span>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={onHide}
                        aria-label="Cerrar"
                        style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#94a3b8',
                            fontSize: '1.05rem',
                            padding: '0.3rem 0.5rem',
                        }}
                    >
                        <i className="pi pi-times" />
                    </button>
                </header>

                <TabView
                    className="udm-tabs"
                    activeIndex={tabIndex}
                    onTabChange={(e) => setTabIndex(e.index)}
                >
                    <TabPanel header="Perfil">
                        <UserProfileTab user={currentUser} toast={toast} onUpdate={reloadUser} />
                    </TabPanel>
                    <TabPanel header="Rol">
                        <UserRoleTab user={currentUser} toast={toast} onUpdate={reloadUser} />
                    </TabPanel>
                    <TabPanel header="Historial">
                        <UserHistoryTab user={currentUser} toast={toast} />
                    </TabPanel>
                </TabView>
            </div>
        </Dialog>
    );
};

export default UserDetailModal;
